export interface AttachedFile {
  status?: UploadStatus;
  file: File;
}

export enum UploadStatus {
  Success = 'Success',
  Failed = 'Failed',
  Loading = 'Loading',
  Empty = 'Empty',
  TooBig = 'TooBig',
}

export interface FileUploadModalData {
  entityId: string;
  url: string;
}
